<template>
  <div class="form">
    <div class="form-card">
      <FormHeader
        :title="formHeaderTitle"
        :datalayerName="datalayerName"
      ></FormHeader>
      <FormSupporterDetails
        :datalayerName="datalayerName"
        :programName="programName"
        :messageId="messageId"

        :sendToIve="sendToIve"
        :iveSupplier="iveSupplier"
        :iveSource="iveSource"
        :iveCampaignId="iveCampaignId"

        :requirePhone="requirePhone"
        :thankYouUrl="thankYouUrl"
        :privacyPolicyUrl="privacyPolicyUrl"
        :title="formSupporterDetailsTitle"
        :subtitle="formSupporterDetailsSubtitle"
      ></FormSupporterDetails>
    </div>
  </div>
</template>

<script>
import FormHeader from "./form-components/Header.vue";
import FormSupporterDetails from "./form-components/SupporterDetails.vue";
import FormMessageViewer from "./form-components/MessageViewer.vue";

export default {
  name: "ActionForm",
  components: {
    FormHeader,
    FormSupporterDetails,
    FormMessageViewer,
  },
  props: {
    datalayerName: {
      type: String,
      required: true,
    },

    // MARKETO
    programName: {
      type: String,
      required: true,
    },

    messageId: {
      type: String,
    },

    sendToIve: {
      type: Boolean,
      default: false,
    },
    iveSupplier: {
      type: String,
      required: false,
    },
    iveSource: {
      type: String,
      required: false,
    },
    iveCampaignId: {
      type: String,
      required: false,
    },

    requirePhone:{
      type: Boolean,
      default: true
    },

    thankYouUrl: {
      type: String,
      default: "https://wwf.org.au/thank-you-for-making-a-difference/"
    },

    privacyPolicyUrl: {
      type: String,
      default:"https://wwf.org.au/about-us/privacy-policy/"
    },
    formHeaderTitle: {
      type: String,
      required: true,
    },
    formSupporterDetailsTitle: {
      type: String,
      required: true,
    },
    formSupporterDetailsSubtitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.form {
  padding: 0 64px;
  width: 100%;
  height: 100%;
}

.form .form-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 124px;
  width: 100%;
  border-radius: 20px;
  border: 0.5px solid #CCC;
  background: #FAFAFA;
  padding: 50px 16px 40px;
}

@media screen and (max-width: 800px) {
  .form {
    padding: 0 16px;
    background-color: #fafafa;
  }

  .form .form-card {
    gap: 40px;
    border: none;
    border-radius: 0;
    padding: 50px 0 40px;
  }
}
</style>



// WEBPACK FOOTER //
// ActionForm.vue?6da80ba0